import { render, staticRenderFns } from "./VehicleStatus.vue?vue&type=template&id=993a3a70&scoped=true&"
import script from "./VehicleStatus.vue?vue&type=script&lang=js&"
export * from "./VehicleStatus.vue?vue&type=script&lang=js&"
import style0 from "./VehicleStatus.vue?vue&type=style&index=0&id=993a3a70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993a3a70",
  null
  
)

export default component.exports